import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { SpeedInsights } from "@vercel/speed-insights/react";

import RequireAuth from "./components/RequireAuth";
import LayoutWithSidebarEN from "./components/ui/LayoutFrontDeskSidebar";
import LayoutBackOffice from "./components/ui/LayoutBackOfficeSidebar";
import HotelDashboardEN from "./components/dashboard/FrontDeskDashboard";
import BackOfficeDashboard from "./components/dashboard/BackOfficeDashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import PaymentSuccess from "./pages/PaymentSuccess";

const APP_VERSION = "1.0.1";

const App: React.FC = () => {
  useEffect(() => {
    const storedVersion = localStorage.getItem("appVer");
    if (storedVersion !== APP_VERSION) {
      localStorage.clear();
      localStorage.setItem("appVer", APP_VERSION);
    }
  }, []);

  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          style: { background: "#f0f0f0" },
          success: { style: { background: "#d1fae5" } },
        }}
      />

      <Routes>
        {/* Public */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Front Desk */}
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <LayoutWithSidebarEN>
                <HotelDashboardEN />
                <SpeedInsights />
              </LayoutWithSidebarEN>
            </RequireAuth>
          }
        />

        {/* BackOfficeDashboard */}
        <Route
          path="/backoffice"
          element={
            <RequireAuth>
              <BackOfficeDashboard />
            </RequireAuth>
          }
        />

        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
